import { Shipment } from '@rye-com/checkout-intents-types';
import { useQuery } from '@tanstack/react-query';
import { checkoutIntentsClient } from 'app/checkout-intents/client';

const fetchShipments = async (checkoutIntentId: string): Promise<Shipment[]> => {
  const client = checkoutIntentsClient.get();
  if (!client) {
    throw new Error('API client not initialized');
  }

  const shipmentsPage = await client.get<{ data: Shipment[] }>(
    `/api/v1/checkout-intents/${checkoutIntentId}/shipments`,
  );
  return shipmentsPage.data;
};

export const useShipments = (checkoutIntentId: string | undefined) => {
  const {
    data: shipments = [],
    isLoading: loading,
    error,
  } = useQuery({
    queryKey: ['shipments', checkoutIntentId],
    queryFn: () => fetchShipments(checkoutIntentId as string),
    enabled: !!checkoutIntentId,
  });

  return {
    shipments,
    loading,
    error: error as Error | null,
  };
};
